import React, { useState, useEffect } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Swal from "sweetalert2";
import { feesfollowup } from "../../../api/FeesDeposite";

import {
  closeModal,
  ToastMain,
  SweetAlertShow,
  LoadingDiv,
} from "../../master/Master";

import { getBatchList } from "../../../api/BatchService";
import DownloadExcel from "../../master/DownloadExcel";
import { useNavigate } from "react-router-dom";
import { counselor, ResponseData } from "../../../api/Calling";
import { followupDataPost } from "../../../api/MarketinService";
import MarketingHeader from "../Marketings/MarketingHeader";

const FollowUp = () => {
  const [data, setdata] = useState([]);
  const [status, setStatus] = useState("");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [type, setType] = useState("");
  const [counse, setcounse] = useState([]);
  const [selectedCounselor, setSelectedCounselor] = useState("");
  const [page, setPage] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [totalStudent, setTotalStudent] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startDate, setStartDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const userData = JSON.parse(localStorage.getItem("user_data"));
  const userId = userData?.id;
  const userType = userData?.staff?.type_id;

  /* =========================
      CREATE RESPONSE
  ========================= */

  const CreateResponse = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const form = e.target;
      const formData = new FormData(form);

      formData.append("counselor_id", selectedCounselor);
      formData.append("type", "marketing");

      const response = await followupDataPost(formData);

      if (response.data.status) {
        ToastMain.fire({
          icon: "success",
          title: response?.data?.message || "Submitted successfully!",
        }).then(() => {
          closeModal("followupModal");
          getResponse();
          form.reset();
        });
      } else {
        if (response?.data?.errors) {
          setError(response?.data?.errors);
        }

        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message || "Something went wrong",
        );
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        setError(error?.response?.data?.errors);
      }

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  /* =========================
      GET FOLLOWUPS
  ========================= */

  const getResponse = async () => {
    let addUrl = `&counselor_id=${selectedCounselor}&start_date=${startDate}&end_date=${endDate}&type=${type}&search=${search}&status=${status}`;

    try {
      const response = await ResponseData(addUrl);

      if (response?.data) {
        setdata(response?.data?.data);
        setTotalStudent(response?.data);
      } else {
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message || "Something went wrong",
        );
      }
    } catch (error) {
      console.error("API Error:", error);

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    }
  };

  useEffect(() => {
    if (selectedCounselor && startDate) {
      getResponse();
    }
  }, [selectedCounselor, type, search, startDate, endDate, status]);

  /* =========================
      COUNSELORS
  ========================= */

  const getcounselor = async () => {
    try {
      const response = await counselor();

      if (response?.data) {
        setcounse(response?.data);
      } else {
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message || "Something went wrong",
        );
      }
    } catch (error) {
      console.error("API Error:", error);

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    }
  };

  useEffect(() => {
    getcounselor();
  }, []);

  /* =========================
      EXPORT
  ========================= */

  const handleDownload = () => {
    const exportData = data?.enquiry || data?.marketing || data?.fees || [];

    if (exportData.length === 0) {
      Swal.fire({
        icon: "info",
        title: "No Data",
        text: "There is no data available to export.",
      });
      return;
    }

    DownloadExcel(
      exportData,
      ["SN", "Student Name", "response", "followup_date"],
      "FollowUp List",
      [
        {
          type: "rename",
          oldKey: "student_name",
          newKey: "Student Name",
        },
        {
          type: "rename",
          oldKey: "father_name",
          newKey: "Father Name",
        },
        {
          type: "add",
          newKey: "Time",
          value: "00:00:00",
        },
      ],
    );
  };

  /* =========================
      HELPERS
  ========================= */

  const getDisplayData = () => {
    if (data?.enquiry?.length) return data.enquiry;
    if (data?.fees?.length) return data.fees;
    if (data?.marketing?.length) return data.marketing;

    return [];
  };

  const getStudentName = (item) => {
    return (
      item?.student_name || item?.student_info?.name || item?.name || "N/A"
    );
  };

  const getFatherName = (item) => {
    return (
      item?.father_name ||
      item?.student_info?.father_name ||
      item?.fathers_name ||
      "N/A"
    );
  };

  const getMobile = (item) => {
    return item?.mobile || item?.student_info?.phone || "N/A";
  };

  const getAddress = (item) => {
    return item?.village || item?.address || "N/A";
  };

  const getCourse = (item) => {
    return (
      item?.course?.title ||
      item?.source?.source_name ||
      item?.batch?.title ||
      "N/A"
    );
  };

  const getDate = (item) => {
    if (!item?.created_at) return "N/A";

    return new Date(item.created_at).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const getInitials = (name = "") => {
    return name
      .split(" ")
      .slice(0, 2)
      .map((word) => word?.[0])
      .join("")
      .toUpperCase();
  };

  const displayData = getDisplayData();

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid py-3">
                {/* =========================
                    MARKETING HEADER
                ========================= */}

                <MarketingHeader />

                {/* =========================
                    PAGE HEADER
                ========================= */}

                <div className="card border-0 shadow-sm mb-4">
                  <div className="card-body">
                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                      <div>
                        <div className="d-flex align-items-center gap-2 mb-1">
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center bg-primary text-white"
                            style={{
                              width: 42,
                              height: 42,
                            }}
                          >
                            <i className="ri-phone-fill"></i>
                          </div>

                          <div>
                            <h4 className="mb-0 fw-bold">Follow Ups</h4>

                            <small className="text-muted">
                              Manage and track your customer follow-ups
                            </small>
                          </div>
                        </div>
                      </div>

                      {selectedCounselor && (
                        <button
                          type="button"
                          className="btn btn-success d-flex align-items-center gap-2 px-3"
                          onClick={handleDownload}
                        >
                          <i className="ri-file-excel-2-fill"></i>
                          Export Excel
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                {/* =========================
                    FILTER CARD
                ========================= */}

                <div className="card border-0 shadow-sm mb-4">
                  <div className="card-header bg-transparent border-0 pb-0">
                    <div className="d-flex align-items-center gap-2">
                      <i className="ri-filter-3-fill text-primary"></i>

                      <h6 className="mb-0 fw-bold">Follow-up Filters</h6>
                    </div>
                  </div>

                  <div className="card-body">
                    <div className="row g-3">
                      {/* COUNSELOR */}

                      <div className="col-xl-3 col-md-6">
                        <label className="form-label fw-semibold">
                          Counselor
                        </label>

                        <div className="input-group">
                          <span className="input-group-text bg-light">
                            <i className="ri-user-star-fill text-primary"></i>
                          </span>

                          <select
                            name="counselor_id"
                            className="form-select"
                            value={selectedCounselor}
                            onChange={(e) => {
                              setSelectedCounselor(e.target.value);
                              setPage(1);
                            }}
                          >
                            <option value="">Select Counselor</option>

                            {counse?.data
                              ?.filter((c) => {
                                if (
                                  c?.user?.id === userId &&
                                  c?.type_id === userType
                                ) {
                                  return true;
                                }

                                const hasMatch = counse?.data?.some(
                                  (item) =>
                                    item?.user?.id === userId &&
                                    item?.type_id === userType,
                                );

                                return !hasMatch;
                              })
                              ?.map((c, index) => (
                                <option key={index} value={c.id}>
                                  {c.name}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>

                      {/* SEARCH */}

                      {selectedCounselor && (
                        <>
                          <div className="col-xl-3 col-md-6">
                            <label className="form-label fw-semibold">
                              Search
                            </label>

                            <div className="input-group">
                              <span className="input-group-text bg-light">
                                <i className="ri-search-line text-primary"></i>
                              </span>

                              <input
                                type="text"
                                className="form-control"
                                placeholder="Name or mobile number"
                                value={search}
                                onChange={(e) => {
                                  setSearch(e.target.value.toUpperCase());
                                  setPage(1);
                                }}
                              />

                              {search && (
                                <button
                                  type="button"
                                  className="btn btn-light border"
                                  onClick={() => setSearch("")}
                                >
                                  <i className="ri-close-line"></i>
                                </button>
                              )}
                            </div>
                          </div>

                          {/* START DATE */}

                          <div className="col-xl-2 col-md-6">
                            <label className="form-label fw-semibold">
                              Start Date
                            </label>

                            <div className="input-group">
                              <span className="input-group-text bg-light">
                                <i className="ri-calendar-line text-primary"></i>
                              </span>

                              <input
                                type="date"
                                className="form-control"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                              />
                            </div>
                          </div>

                          {/* END DATE */}

                          <div className="col-xl-2 col-md-6">
                            <label className="form-label fw-semibold">
                              End Date
                            </label>

                            <div className="input-group">
                              <span className="input-group-text bg-light">
                                <i className="ri-calendar-check-line text-primary"></i>
                              </span>

                              <input
                                type="date"
                                className="form-control"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                              />
                            </div>
                          </div>

                          {/* RESET */}

                          <div className="col-xl-2 col-md-6 d-flex align-items-end">
                            <button
                              type="button"
                              className="btn btn-outline-primary w-100"
                              onClick={() => {
                                const today = new Date()
                                  .toISOString()
                                  .split("T")[0];

                                setStartDate(today);
                                setEndDate("");
                                setSearch("");
                                setStatus("");
                                setPage(1);
                              }}
                            >
                              <i className="ri-refresh-line me-1"></i>
                              Today
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* =========================
                    EMPTY STATE
                ========================= */}

                {!selectedCounselor && (
                  <div className="card border-0 shadow-sm">
                    <div className="card-body py-5">
                      <div className="text-center">
                        <div
                          className="mx-auto mb-3 rounded-circle bg-primary-subtle d-flex align-items-center justify-content-center"
                          style={{
                            width: 70,
                            height: 70,
                          }}
                        >
                          <i className="ri-group-line fs-2 text-primary"></i>
                        </div>

                        <h5 className="fw-bold mb-2">Select a Counselor</h5>

                        <p className="text-muted mb-0">
                          Select a counselor above to view and manage follow-up
                          records.
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                {/* =========================
                    RESULTS
                ========================= */}

                {selectedCounselor && (
                  <div className="card border-0 shadow-sm">
                    {/* RESULTS HEADER */}

                    <div className="card-header bg-transparent border-0">
                      <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                        <div>
                          <h5 className="mb-1 fw-bold">Follow-up Records</h5>

                          <div className="d-flex align-items-center gap-2">
                            <span className="badge bg-primary">
                              {totalStudent?.total || 0} Records
                            </span>

                            {search && (
                              <small className="text-muted">
                                Searching for "{search}"
                              </small>
                            )}
                          </div>
                        </div>

                        {/* STATUS FILTER */}

                        <div className="d-flex flex-wrap gap-2">
                          <button
                            type="button"
                            className={`btn btn-sm ${
                              status === ""
                                ? "btn-primary"
                                : "btn-outline-secondary"
                            }`}
                            onClick={() => setStatus("")}
                          >
                            All
                          </button>

                          <button
                            type="button"
                            className={`btn btn-sm ${
                              status === "hot"
                                ? "btn-danger"
                                : "btn-outline-danger"
                            }`}
                            onClick={() => setStatus("hot")}
                          >
                            <i className="ri-fire-fill me-1"></i>
                            Hot
                          </button>

                          <button
                            type="button"
                            className={`btn btn-sm ${
                              status === "follow_up"
                                ? "btn-warning text-dark"
                                : "btn-outline-warning"
                            }`}
                            onClick={() => setStatus("follow_up")}
                          >
                            <i className="ri-history-line me-1"></i>
                            Follow Up
                          </button>

                          <button
                            type="button"
                            className={`btn btn-sm ${
                              status === "not_interested"
                                ? "btn-secondary"
                                : "btn-outline-secondary"
                            }`}
                            onClick={() => setStatus("not_interested")}
                          >
                            <i className="ri-close-circle-line me-1"></i>
                            Not Interested
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* TABLE */}

                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0">
                          <thead>
                            <tr>
                              <th
                                className="text-muted fw-semibold"
                                style={{ width: "55px" }}
                              >
                                #
                              </th>

                              <th className="fw-semibold">Student</th>

                              <th className="fw-semibold">Father Name</th>

                              <th className="fw-semibold">Contact</th>

                              <th className="fw-semibold">Location</th>

                              <th className="fw-semibold">Course / Source</th>

                              <th className="fw-semibold">Created</th>

                              <th
                                className="text-center fw-semibold"
                                style={{ width: "140px" }}
                              >
                                Action
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {displayData?.length > 0 ? (
                              displayData.map((item, i) => {
                                const studentName = getStudentName(item);

                                return (
                                  <tr key={item.id || i}>
                                    {/* INDEX */}

                                    <td className="text-muted">{i + 1}</td>

                                    {/* STUDENT */}

                                    <td>
                                      <div className="d-flex align-items-center gap-2">
                                        <div
                                          className="rounded-circle bg-primary-subtle text-primary fw-bold d-flex align-items-center justify-content-center flex-shrink-0"
                                          style={{
                                            width: 38,
                                            height: 38,
                                            fontSize: "12px",
                                          }}
                                        >
                                          {getInitials(studentName)}
                                        </div>

                                        <div>
                                          <button
                                            type="button"
                                            className="btn btn-link p-0 text-primary fw-semibold text-decoration-none"
                                            data-bs-target="#Viewfollowup"
                                            data-bs-toggle="modal"
                                            onClick={() => setModalData(item)}
                                          >
                                            {studentName}
                                          </button>

                                          <div>
                                            <small className="text-muted">
                                              ID: {item?.id || "—"}
                                            </small>
                                          </div>
                                        </div>
                                      </div>
                                    </td>

                                    {/* FATHER */}

                                    <td>
                                      <span className="text-capitalize">
                                        {getFatherName(item)}
                                      </span>
                                    </td>

                                    {/* MOBILE */}

                                    <td>
                                      <a
                                        href={`tel:${getMobile(item)}`}
                                        className="text-decoration-none"
                                      >
                                        <i className="ri-phone-line me-1 text-success"></i>

                                        {getMobile(item)}
                                      </a>
                                    </td>

                                    {/* ADDRESS */}

                                    <td>
                                      <span
                                        className="text-muted text-truncate d-inline-block"
                                        style={{
                                          maxWidth: "160px",
                                        }}
                                        title={getAddress(item)}
                                      >
                                        <i className="ri-map-pin-line me-1"></i>
                                        {getAddress(item)}
                                      </span>
                                    </td>

                                    {/* COURSE */}

                                    <td>
                                      <span className="badge bg-label-primary text-primary">
                                        {getCourse(item)}
                                      </span>
                                    </td>

                                    {/* DATE */}

                                    <td>
                                      <div className="d-flex align-items-center gap-1">
                                        <i className="ri-calendar-line text-muted"></i>

                                        <span className="small">
                                          {getDate(item)}
                                        </span>
                                      </div>
                                    </td>

                                    {/* ACTION */}

                                    <td className="text-center">
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm d-inline-flex align-items-center gap-1"
                                        data-bs-toggle="modal"
                                        data-bs-target="#followupModal"
                                        onClick={() => {
                                          setModalData(item);
                                          setError("");
                                        }}
                                      >
                                        <i className="ri-phone-fill"></i>
                                        Follow Up
                                      </button>
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="8" className="text-center py-5">
                                  <div>
                                    <div
                                      className="mx-auto mb-3 rounded-circle bg-light d-flex align-items-center justify-content-center"
                                      style={{
                                        width: 60,
                                        height: 60,
                                      }}
                                    >
                                      <i className="ri-inbox-line fs-3 text-muted"></i>
                                    </div>

                                    <h6 className="fw-bold">
                                      No follow-ups found
                                    </h6>

                                    <p className="text-muted mb-0">
                                      Try changing your search, dates, or status
                                      filter.
                                    </p>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {/* =========================
                          PAGINATION
                      ========================= */}

                      {data?.links?.length > 0 && (
                        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mt-4 pt-3 border-top">
                          <small className="text-muted">
                            Showing <strong>{data?.from || 0}</strong> to{" "}
                            <strong>{data?.to || 0}</strong> of{" "}
                            <strong>{data?.total || 0}</strong> records
                          </small>

                          <nav>
                            <ul className="pagination pagination-sm mb-0">
                              {data.links.map((btn, i) => (
                                <li
                                  key={i}
                                  className={`page-item ${
                                    btn?.active ? "active" : ""
                                  } ${!btn?.url ? "disabled" : ""}`}
                                >
                                  <button
                                    type="button"
                                    className="page-link"
                                    onClick={() => {
                                      if (!btn?.url) return;

                                      if (data?.links?.length === i + 1) {
                                        setPage(data.current_page + 1);
                                      } else if (i === 0) {
                                        setPage(data.current_page - 1);
                                      } else {
                                        setPage(btn.label);
                                      }
                                    }}
                                  >
                                    {data?.links?.length === i + 1 ? (
                                      <i className="ri-arrow-right-s-line"></i>
                                    ) : i === 0 ? (
                                      <i className="ri-arrow-left-s-line"></i>
                                    ) : (
                                      btn?.label
                                    )}
                                  </button>
                                </li>
                              ))}
                            </ul>
                          </nav>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ======================================================
          VIEW FOLLOW-UP HISTORY MODAL
      ====================================================== */}

      <div
        className="modal fade"
        id="Viewfollowup"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
          <div className="modal-content border-0 shadow">
            {/* HEADER */}

            <div className="modal-header border-0 bg-primary text-white">
              <div className="d-flex align-items-center gap-3">
                <div
                  className="rounded-circle bg-white bg-opacity-25 d-flex align-items-center justify-content-center"
                  style={{
                    width: 42,
                    height: 42,
                  }}
                >
                  <i className="ri-history-line"></i>
                </div>

                <div>
                  <h5 className="modal-title mb-0">Follow-up History</h5>

                  <small className="opacity-75">
                    {getStudentName(modalData)}
                  </small>
                </div>
              </div>

              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
              />
            </div>

            {/* STUDENT INFO */}

            <div className="modal-body">
              <div className="row g-3 mb-4">
                <div className="col-md-6">
                  <div className="p-3 rounded bg-light">
                    <small className="text-muted d-block mb-1">Student</small>

                    <strong>{getStudentName(modalData)}</strong>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="p-3 rounded bg-light">
                    <small className="text-muted d-block mb-1">
                      Father Name
                    </small>

                    <strong>{getFatherName(modalData)}</strong>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="p-3 rounded bg-light">
                    <small className="text-muted d-block mb-1">Mobile</small>

                    <strong>{getMobile(modalData)}</strong>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="p-3 rounded bg-light">
                    <small className="text-muted d-block mb-1">Counselor</small>

                    <strong>{modalData?.counselor?.name || "N/A"}</strong>
                  </div>
                </div>
              </div>

              {/* TIMELINE */}

              <div className="d-flex align-items-center gap-2 mb-3">
                <i className="ri-list-check-2 text-primary"></i>

                <h6 className="mb-0 fw-bold">Response Timeline</h6>
              </div>

              {modalData?.followup_transactions?.length > 0 ? (
                <div
                  className="timeline-container"
                  style={{
                    maxHeight: "400px",
                    overflowY: "auto",
                  }}
                >
                  {modalData.followup_transactions.map((transaction, index) => (
                    <div
                      key={transaction.id || index}
                      className="d-flex gap-3 mb-3"
                    >
                      {/* TIMELINE DOT */}

                      <div className="d-flex flex-column align-items-center">
                        <div
                          className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                          style={{
                            width: 34,
                            height: 34,
                            fontSize: "12px",
                          }}
                        >
                          {index + 1}
                        </div>

                        {index !==
                          modalData.followup_transactions.length - 1 && (
                          <div
                            style={{
                              width: 2,
                              flex: 1,
                              minHeight: 40,
                              background: "#e5e7eb",
                            }}
                          />
                        )}
                      </div>

                      {/* EVENT */}

                      <div className="flex-grow-1 border rounded p-3 mb-2">
                        <div className="d-flex justify-content-between gap-2 mb-2">
                          <strong>Follow-up #{index + 1}</strong>

                          <small className="text-muted">
                            {transaction.date || "—"}
                          </small>
                        </div>

                        <p className="mb-2 text-muted">
                          {transaction.response || "No response"}
                        </p>

                        <div className="d-flex align-items-center gap-2">
                          <span className="badge bg-label-warning text-warning">
                            <i className="ri-calendar-event-line me-1"></i>
                            Next Follow-up
                          </span>

                          <small>
                            {transaction.next_followup_date || "Not scheduled"}
                          </small>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-5">
                  <i className="ri-chat-3-line fs-1 text-muted"></i>

                  <h6 className="mt-3">No follow-up history</h6>

                  <p className="text-muted mb-0">
                    No responses have been recorded for this student yet.
                  </p>
                </div>
              )}
            </div>

            <div className="modal-footer border-0">
              <button
                type="button"
                className="btn btn-light"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ======================================================
          ADD FOLLOW-UP MODAL
      ====================================================== */}

      <div
        className="modal fade"
        id="followupModal"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
          <div className="modal-content border-0 shadow">
            <form onSubmit={CreateResponse}>
              {/* HEADER */}

              <div className="modal-header border-0">
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="rounded-circle bg-primary-subtle text-primary d-flex align-items-center justify-content-center"
                    style={{
                      width: 44,
                      height: 44,
                    }}
                  >
                    <i className="ri-phone-fill"></i>
                  </div>

                  <div>
                    <h5 className="modal-title fw-bold mb-0">Add Follow-up</h5>

                    <small className="text-muted">Record a new response</small>
                  </div>
                </div>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                />
              </div>

              <div className="modal-body">
                {/* STUDENT CARD */}

                <div className="bg-light rounded p-3 mb-4">
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="rounded-circle bg-primary text-white fw-bold d-flex align-items-center justify-content-center"
                      style={{
                        width: 48,
                        height: 48,
                      }}
                    >
                      {getInitials(getStudentName(modalData))}
                    </div>

                    <div>
                      <h6 className="mb-1 fw-bold">
                        {getStudentName(modalData)}
                      </h6>

                      <div className="d-flex flex-wrap gap-3">
                        <small className="text-muted">
                          <i className="ri-user-line me-1"></i>
                          {getFatherName(modalData)}
                        </small>

                        <small className="text-muted">
                          <i className="ri-phone-line me-1"></i>
                          {getMobile(modalData)}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                <input
                  type="hidden"
                  name="user_id"
                  value={modalData?.id || ""}
                />

                {/* PREVIOUS RESPONSES */}

                <div className="mb-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="fw-bold mb-0">Previous Responses</h6>

                    <span className="badge bg-secondary">
                      {modalData?.followup_transactions?.length || 0} Records
                    </span>
                  </div>

                  <div
                    className="border rounded p-3"
                    style={{
                      maxHeight: "240px",
                      overflowY: "auto",
                    }}
                  >
                    {modalData?.followup_transactions?.length > 0 ? (
                      modalData.followup_transactions.map((resp, index) => (
                        <div
                          key={resp.id || index}
                          className={`d-flex gap-3 ${
                            index !== modalData.followup_transactions.length - 1
                              ? "pb-3 mb-3 border-bottom"
                              : ""
                          }`}
                        >
                          <div
                            className="rounded-circle bg-primary-subtle text-primary d-flex align-items-center justify-content-center flex-shrink-0"
                            style={{
                              width: 32,
                              height: 32,
                              fontSize: 12,
                            }}
                          >
                            {index + 1}
                          </div>

                          <div className="flex-grow-1">
                            <div className="d-flex justify-content-between mb-1">
                              <strong className="small">
                                Follow-up #{index + 1}
                              </strong>

                              <small className="text-muted">
                                {resp.date || "—"}
                              </small>
                            </div>

                            <p className="small mb-2">{resp.response || "—"}</p>

                            <small className="text-muted">
                              <i className="ri-calendar-event-line me-1"></i>
                              Next: {resp.next_followup_date || "Not scheduled"}
                            </small>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-center py-4">
                        <i className="ri-chat-1-line fs-3 text-muted"></i>

                        <p className="text-muted mb-0 mt-2">
                          No previous responses.
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* RESPONSE */}

                <div className="mb-4">
                  <label className="form-label fw-semibold">Response</label>

                  <textarea
                    className="form-control"
                    name="response"
                    placeholder="Enter the conversation / follow-up response..."
                    style={{
                      minHeight: "120px",
                      resize: "vertical",
                    }}
                    required
                  />

                  {error?.response && (
                    <small className="text-danger">{error.response}</small>
                  )}
                </div>

                {/* NEXT FOLLOWUP */}

                <div className="row g-3">
                  {type === "fees" && (
                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Amount</label>

                      <div className="input-group">
                        <span className="input-group-text">₹</span>

                        <input
                          type="number"
                          className="form-control"
                          name="amount"
                          placeholder="Enter amount"
                          required
                        />
                      </div>

                      {error?.amount && (
                        <small className="text-danger">{error.amount}</small>
                      )}
                    </div>
                  )}

                  <div className={type === "fees" ? "col-md-6" : "col-md-12"}>
                    <label className="form-label fw-semibold">
                      Next Follow-up Date
                    </label>

                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="ri-calendar-event-line"></i>
                      </span>

                      <input
                        type="date"
                        className="form-control"
                        name="next_followup_date"
                        required
                      />
                    </div>

                    {error?.next_followup_date && (
                      <small className="text-danger">
                        {error.next_followup_date}
                      </small>
                    )}
                  </div>
                </div>
              </div>

              {/* FOOTER */}

              <div className="modal-footer border-0">
                <button
                  type="button"
                  className="btn btn-light"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="btn btn-primary px-4"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      />
                      Saving...
                    </>
                  ) : (
                    <>
                      <i className="ri-checkbox-circle-line me-1"></i>
                      Save Follow-up
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default FollowUp;
